/**
 * ConfirmDeleteDialog — Wiederverwendbare Sicherheitsabfrage vor
 * destruktiven Aktionen (Löschen). Wraps Shadcn AlertDialog.
 *
 * Verwendung:
 *   <ConfirmDeleteDialog
 *     trigger={<Button variant="ghost"><Trash2 /></Button>}
 *     title="Wirklich löschen?"
 *     description="Diese Aktion kann nicht rückgängig gemacht werden."
 *     onConfirm={() => removeItem(id)}
 *     testIdPrefix="training-123"
 *   />
 */
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from './alert-dialog';

export const ConfirmDeleteDialog = ({
  // Uncontrolled mode: render <trigger> as AlertDialogTrigger
  trigger,
  // Controlled mode: parent verwaltet open-State (z.B. wenn Trigger ein
  // DropdownMenuItem ist, der das Menu schliesst)
  open,
  onOpenChange,
  title = 'Wirklich löschen?',
  description = 'Diese Aktion kann nicht rückgängig gemacht werden.',
  confirmLabel = 'Löschen',
  cancelLabel = 'Abbrechen',
  onConfirm,
  testIdPrefix = 'confirm-delete',
}) => {
  const isControlled = open !== undefined;
  return (
    <AlertDialog
      {...(isControlled ? { open, onOpenChange } : {})}
    >
      {trigger && (
        <AlertDialogTrigger asChild data-testid={`${testIdPrefix}-trigger`}>
          {trigger}
        </AlertDialogTrigger>
      )}
      <AlertDialogContent data-testid={`${testIdPrefix}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testIdPrefix}-cancel`}>
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            data-testid={`${testIdPrefix}-confirm`}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmDeleteDialog;
